jQuery(document).ready(function ($) {
  // Use delegated event handling for dynamically added elements
  $(document).on("click", ".send-verification-email", function (e) {
    e.preventDefault();
    let button = $(this);
    let message = $('.verification-text');

    button.text("Sender epost...");

    // AJAX request
    $.ajax({
      url: script_object.ajax_url,
      type: "POST",
      data: {
        action: "ajax_send_verification_email",
      },
      success: function (response) {
        button.prop("disabled", true);
        button.text("Epost sendt");
        message.text("E-post er sendt. Vennligst sjekk innboksen din!")
        message.attr("style", "color: green")
        button.remove();
      },
      error: function () {
        // Show an error message
        button.text("An error occurred. Please try again.");
      },
    });
  });

  // Close modal of invalid verification email
  $("#invalid-email-close-modal").on("click", function () {
    $(".invalid-email-modal").hide();
  });
});
